import navGroup, { getNavGroupForUser } from './components/items/items';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [navGroup]
};

/**
 * Navigation for sidebar and breadcrumbs. When `isRestricted` is true (External group),
 * Match Probabilities and Health Check are omitted.
 */
export function getMenuItemsForUser(isRestricted) {
  return {
    items: [getNavGroupForUser(isRestricted)]
  };
}

export default menuItems;
